<template>
   <el-footer height="auto">
    <div class="footer container">
      <div class="middle">
        <div class="middle_url">
          <a target="_blank"  href="/about">About Us </a> |
          <a target="_blank" href="/disclaimer">Disclaimer</a> |
          <a target="_blank" href="/legal/1">Privacy Policy</a> |
          <a target="_blank" href="/legal/2">Terms & Conditions </a> |
          <a target="_blank" href="/legal/3">Refund</a>
        </div>
        <div class="icon">
          <a href="/" class="logo"></a>
        </div>
         <div class="copyright">
          <p>Copyright©Findchip. All Rights Reserved</p>
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      input: '',
      show: false,
      PC_VERSON: '',
      FB_VERSON: '',
      checked: false,
      subscribe_error: '',
      subscribe_step: 0,
      if_valid: false
    }
  },
  props: ['hidedata'],
  methods: {
    toBury (key, f1, f2, f3, f4, f5) {
      this.$axios.get(
        'https://client-click.cn-hongkong.log.aliyuncs.com/logstores/client-logstroe/track',
        {
          params: {
            APIVersion: '0.6.0',
            __topic__: key,
            f1,
            f2,
            f3,
            f4,
            f5,
            log_type: 10001
          }
        }
      )
    }
  },
  created () {
    // this.PC_VERSON = PC_VERSON
    // this.FB_VERSON = FB_VERSON
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-footer {
  position: relative;
  font-size: 14px;
  color: #e7e7e7;
  background-color: #073a2b;
  background-image: url('/pc/static/img/hom/bottom.jpg');
  background-size:auto 100%;
  background-position: center bottom;
  background-repeat: no-repeat;
  .footer {
    position: relative;
    padding: 100px 10px 150px 10px;
    .f-line {
      width: 100%;
      height: 1px;
      background-color: #333333;
      margin: 60px 0px 10px 0px;
    }
    .middle {
      position: relative;
      margin-top: 0px;
      text-align: center;
      min-height: 54px;
      .middle_url {
        a {
          font-size: 16px;
          margin: 8px 20px;
          display: inline-block;
          text-decoration: none;
          &:hover {
            color: #f5b601 ;
          }
        }
      }
      .icon {
        position: relative;
        top: 16px;
        right: 0px;
        text-align: center;
        a {
          margin: 30px 20px;
          display: inline-block;
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center center;
          width: 16px;
          height: 36px;
          // &:hover {
          //   transform: scale(1.1);
          // }
        }
        a {
          -webkit-transition: all cubic-bezier(.165,.84,.44,1) .3s;
          -o-transition: all cubic-bezier(.165,.84,.44,1) .3s;
          transition: all cubic-bezier(.165,.84,.44,1) .3s;
          -webkit-transform: scale(1);
          -ms-transform: scale(1);
          transform: scale(1);
        }
        a:hover {
          -webkit-transform: scale(1.1);
          -ms-transform: scale(1.1);
          transform: scale(1.1);
        }
        .logo {
          background-image: url(/pc/static/img/hom/findchip.png);
          width: 161px;
          height: 50px;
        }
      }
    }
    .copyright {
      position: relative;
      text-align: center;
      min-height: 50px;
      p {
        display: inline-block;
        color: #8e8e8e;
        font-size: 14px;
        margin-top: 15px;
      }
    }
  }
}
</style>
